/**
 * Up to three initials for a rescue's badge mark.
 *
 * Shared by the offer screen and the checkout so the same rescue cannot render as "KHS" on one screen
 * and something else on the next.
 */
export function rescueInitials(orgName: string): string {
  return orgName
    .split(' ')
    .map((word) => word.charAt(0))
    .join('')
    .slice(0, 3)
    .toUpperCase();
}
